<template>
  <transition
    appear
    @before-appear="beforeAppear"
    @appear="enter"
    @enter="enter"
    @leave="leave">
    <div
      v-hover-scale-mouse
      data-apollo-hover
      class="arrow"
      @mouseenter="arrowMouseOver"
      @mouseleave="mLeave">
      <div class="arrow__wrapper" :class="{'inverted': inverted}">
        <div ref="thinLine" class="arrow__line"></div>
        <div
          v-show="resourcesLoaded"
          ref="line"
          class="arrow__hover-line"></div>
        <staggering-transition :is-over="isOver" @staggering="toggleIsInTransition">
          <h3
            v-if="!icon"
            class="arrow__text"
            :key="text">
            {{text}}
          </h3>
          <cross-icon v-else class="arrow__img"/>
        </staggering-transition>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable no-param-reassign, no-unused-expressions */
import { mapState } from 'vuex';
import anime from 'animejs';

import letterSpacingAnimation from '@/mixins/letterSpacingAnimation';
// import hoverSound from '@/mixins/hoverSound';

import CrossIcon from '@/assets/svg/close.svg';

import StaggeringTransition from '@/components/StaggeringTransition.vue';

export default {
  name: 'Arrow',
  components: {
    StaggeringTransition,
    CrossIcon,
  },
  mixins: [letterSpacingAnimation],
  props: {
    inverted: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      lineIsAnimating: false,
    };
  },
  computed: {
    ...mapState([
      'loaderIsOpen',
      'resourcesLoaded',
    ]),
  },
  methods: {
    foregroundLine(el, delay = 0) {
      const { thinLine } = this.$refs;
      if (!this.lineIsAnimating) {
        this.lineIsAnimating = true;
        this.inverted
          ? el.style.transformOrigin = 'top'
          : el.style.transformOrigin = 'bottom';
        anime({
          targets: el,
          scaleY: [0, 1],
          duration: 300,
          easing: 'easeOutSine',
          loop: 2,
          direction: 'alternate',
          delay,
          loopComplete: () => {
            thinLine.style.opacity = 1;
            this.inverted
              ? el.style.transformOrigin = 'bottom'
              : el.style.transformOrigin = 'top';
          },
          complete: () => {
            this.lineIsAnimating = false;
          },
        });
      }
    },
    arrowMouseOver(ev) {
      this.foregroundLine(this.$refs.line);
      this.mEnter(ev);
    },
    beforeAppear(el) {
      anime.set(el, {
        opacity: 0,
      });
    },
    enter(el, done) {
      anime.remove(el);
      anime({
        targets: el,
        opacity: 1,
        duration: 800,
        easing: 'easeInCubic',
        complete() {
          done();
        },
      });
    },
    leave(el, done) {
      anime.remove(el);
      anime({
        targets: el,
        opacity: 0,
        duration: 300,
        easing: 'easeOutCubic',
        complete() {
          done();
        },
      });
    },
  },
  mounted() {
    this.foregroundLine(this.$refs.line, 700);
  },
};
</script>

<style scoped lang="scss">
.arrow {
  display: inline-block;
  text-align: center;
  cursor: pointer;

  &__wrapper {
    display: flex;
    flex-direction: column;

    &.inverted {
      flex-direction: column-reverse;

      .arrow__text {
        transform: translateY(25%);
      }
      .arrow__hover-line {
        top: auto;
        bottom: 0
      }
    }
  }

  &__text {
    margin: 1rem 0;
    text-transform: uppercase;

    transform: translateY(-25%);

  }

  &__img {
    width: 1rem;
    box-sizing: content-box;
    padding: 1rem;
  }

  &__line,
  &__hover-line {

    position: relative;
    margin: 0 auto;

    width: 1px;
    height: 3.2rem;

    background-color: $color-primary;

    @include mq(mobileL) {
      height: calc(9.2vw - 1.5rem);
    }

    @include mq(ds) {
      height: calc(5.2vw - 1.5rem);
    }
  }

  &__line {
    opacity: 0;
  }

  &__hover-line {
    width: 3px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: auto;

    transform: scaleY(0);
  }
}

.fade {
  &-enter-active {
    transition: opacity 600ms cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  &-leave-active {
    transition: opacity 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
